import React, { useState } from "react";
import "./Singup.css";
import coderwinglogo from "../Image/coderwing-logo.png";
import { Eye, EyeOff } from "lucide-react";
const apiUrl = process.env.REACT_APP_API_BASE_URL;
function Signup() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    isAdmin: false, 
    agreeTerms: false,
  });

  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    try {
      const response = await fetch(`${apiUrl}/api/auth/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.msg || "Registration failed");
      }

      localStorage.setItem("token", data.token);
      localStorage.setItem("isAdmin", data.isAdmin);

      setSuccess("User registered successfully!");

      setTimeout(() => {
        window.location.href = data.isAdmin ? "/Dashboard" : "/"; 
      }, 2000);
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div className="signup-container">
      <div className="signup-left">
        <div className="logo-container">
          <div className="logo">
            <img src={coderwinglogo} alt="Coderwing Logo" className="logo-text" />
          </div>
          <button className="signin-top">Sign In</button>
        </div>

        <div className="signup-form-container">
          <h1 className="title">Create your Coderwing account</h1>
          <p className="subtitle">
            Develop industry-ready skills and secure your future with our courses.
          </p>

          {error && <p className="error-message">{error}</p>}
          {success && <p className="success-message">{success}</p>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                placeholder="Enter your name..."
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Enter your email..."
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <div className="password-input-container">
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  placeholder="Enter your password..."
                  value={formData.password}
                  onChange={handleChange}
                  required
                />
                <span className="eye-icon" onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <EyeOff /> : <Eye />}
                </span>
              </div>
            </div>

          
            {/* <div className="form-group checkbox-group">
              <input
                type="checkbox"
                id="isAdmin"
                name="isAdmin"
                checked={formData.isAdmin}
                onChange={handleChange}
              />
              <label htmlFor="isAdmin">Register as Admin</label>
            </div> */}

            <div className="form-group checkbox-group">
              <input
                type="checkbox"
                id="agreeTerms"
                name="agreeTerms"
                checked={formData.agreeTerms}
                onChange={handleChange}
                required
              />
              <label htmlFor="agreeTerms">I agree with terms & conditions</label>
            </div>

            <button type="submit" className="create-account-button">
              Create your account
            </button>
          </form>
        </div>
      </div>

      <div className="signup-right"></div>
    </div>
  );
}

export default Signup;
